/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { FunctionComponent, h } from 'preact';

import { IconProps } from '../../types';

export const PasskeysIcon: FunctionComponent<IconProps> = ({
  name, description, width, height,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 48}
    height={height || 48}
    fill="none"
    aria-labelledby={name}
    role="img"
    viewBox="-5 -5 45 45"
  >
    <title id={name}>{description}</title>
    <path
      d="M25.4311 7.75813C28.4403 7.58607 31.1652 9.63438 31.8403 12.5634C32.3867 14.9336 31.5039 17.4163 29.596 18.8967L29.5797 20.4919C29.2854 20.7879 28.9676 21.0599 28.6656 21.3472C28.609 21.4012 28.4897 21.4839 28.5745 21.5533L29.5629 22.5611L29.5838 22.6083L29.5724 23.5267L28.4965 24.6734C28.8542 25.0489 29.2492 25.3912 29.5797 25.7902V27.8694L25.923 30.8824C24.8915 30.0384 23.8451 29.2109 22.8177 28.3615C22.7406 28.2975 22.2555 27.9093 22.2437 27.8694L22.2392 19.1123C22.2296 19.0624 21.9739 18.9021 21.9109 18.8508C17.4816 15.2282 19.7509 8.08362 25.4306 7.75858L25.4311 7.75813ZM23.7997 18.1735L23.8038 27.0786L23.9285 27.2261L25.9189 28.835L27.9855 27.1353V26.4099L26.3411 24.742L26.3188 24.6957L27.8382 23.0614L26.2753 21.4294L27.9855 19.8264L28.0082 18.0559C30.3913 16.7444 31.1652 13.6534 29.63 11.3708C27.7198 8.53123 23.4597 8.69693 21.759 11.6627C20.411 14.0138 21.3677 17.0341 23.7993 18.1735H23.7997Z"
      fill="#4459DB"
    />
    <path
      d="M17.6921 11.7331C14.1171 14.9849 8.31991 12.9225 7.60172 8.16448C6.87991 3.38556 11.6859 -0.320643 16.1111 1.66456C20.1038 3.45547 20.9371 8.78233 17.6921 11.7336V11.7331ZM13.2348 2.71913C9.94897 2.9443 8.06419 6.67047 9.72998 9.50641C11.4837 12.4922 15.8758 12.459 17.5507 9.42379C19.3135 6.22876 16.8429 2.47217 13.2348 2.71913Z"
      fill="#272727"
    />
    <path
      d="M1.56377 28.3155L0 28.089C0.236221 26.5605 0.68554 25.0633 1.28176 23.641C2.92125 19.7291 5.84658 16.2903 10.1521 15.3624C12.8711 14.7764 15.6931 15.2462 18.2607 16.2182L18.7907 17.6863C18.7948 17.7498 18.5395 17.7939 18.4815 17.8002C17.9297 17.8624 17.3788 17.5624 16.856 17.3976C14.7795 16.7416 12.5524 16.4424 10.4019 16.9286C5.2889 18.084 2.37899 23.5089 1.56423 28.3155H1.56377Z"
      fill="#272727"
    />
    <path
      d="M8.13669 23.8695C7.55634 25.664 7.19725 27.5244 6.88168 29.3843L6.791 29.4065L5.32788 29.1787C5.38184 28.6611 5.48612 28.1436 5.58405 27.6311C5.86244 26.1775 6.18707 24.7229 6.66632 23.3234L8.13669 23.8695Z"
      fill="#272727"
    />
    <path
      d="M25.6805 11.4806C27.4982 11.3957 28.6652 13.4064 27.6986 14.9535C26.8095 16.3762 24.6853 16.3526 23.8374 14.9017C22.9755 13.4263 23.9794 11.5601 25.681 11.4806H25.6805ZM25.6565 13.0682C24.8195 13.2003 24.9614 14.5703 25.9176 14.4192C26.7455 14.2884 26.5882 12.9211 25.6565 13.0682Z"
      fill="#272727"
    />
  </svg>
);
